import { Input } from "../Input";
import { SearchIcon } from "../../constant";
import classes from "./SearchInput.module.css";
const SearchInput = ({ value, onChange, placeholder }) => {
  return (
    <Input
      className={classes.searchWrapper}
      isOptional={true}
      value={value}
      inputStyle={{ paddingBlock: "14px", width: "280px" }}
      placeholder={placeholder}
      customStyle={{
        // paddingBlock: "14px",
        paddingRight: "16px",
        background: "var(--white-color)",
        borderRadius: "17px",
        border: "1px solid var(--white-color)",
      }}
      type="text"
      onChange={onChange}
      rightIcon={
        <span>
          <SearchIcon />
        </span>
      }
    />
  );
};

export default SearchInput;
